import React, { memo, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { PERFORMING_AUDIENCES_COLUMNS } from '../../../../../../constants';
import arrayToDropdownValues from '../../../../../../utils/arrayToDropdownValues';
import MultiselectDropdownNew from '../../../../../../components/multiselect-dropdown/MultiselectDropdownNew';

function FilterColumnsSelect({ selectedFilters, onChangeFilters }) {
  const filterColumns = useSelector((state) => state.resonance.filterColumns);

  const filterOptions = filterColumns.map((column) => ({
    label: column.header,
    value: column.header,
  }));

  const initializeFilters = () => {
    const initialFilters = filterColumns.filter((column) => PERFORMING_AUDIENCES_COLUMNS.includes(column.type));

    onChangeFilters(arrayToDropdownValues(initialFilters.map((column) => column.header)));
  };

  useEffect(() => {
    if (!selectedFilters.length && filterColumns.length > 0) {
      initializeFilters();
    }
  }, [selectedFilters, onChangeFilters, filterColumns]);

  return <MultiselectDropdownNew options={filterOptions} value={selectedFilters} onChange={onChangeFilters} />;
}

export default memo(FilterColumnsSelect);
